import { defineStore } from 'pinia'
import type { ICurrencyItem, ICurrencyCountry, ICurrencyList, ICountries } from '~/types/currencyItem'
import type { ICartInfo } from "~/types/cart";

const cookieOptions = {
    maxAge: 60 * 60 * 24 * 30,
    path: '/'
};

export const useWooStore = defineStore("woo", {
    state: () => ({
        wcId: '',
        totalItemCart: 0,
        singleProduct: {
            status: 'instock',
            variationId: 0
        },
        carts: {
            carts: {

            },
            info: {
                subtotal: '',
                saving: '',
                coupons: {},
                congration: {
                    title: '',
                    message: '',
                    percentage: ''
                }
            },
            promos: {

            },
            categories: [],
            total_items: 0
        },
        currency: {
            default: true,
            flag: "https://www.skjewellery.com.my/api/wp-content/uploads/nuxt/malaysia.webp",
            url: "",
            phonecode: "60",
            rate: "1",
            position: "left",
            decimal: "0",
            label: "Malaysia",
            country_short: "MY",
            symbol: "RM",
            thousand_sep: ",",
            price_format: "%1$s%2$s",
            zone_id: "",
            extra_countries: [] as string[],
            currency: "MYR",
            decimal_sep: ""
        },
        currencyList: {
            enable: "",
            settings: {} as Record<string, ICurrencyItem>
        },
        newsletterShowed: false,
        newsletterData: '',
        newsletterTriggerCount: 0,
        currentCountry: 'MY',
        country: {
            label: "",
            flag: "",
            country_short: "",
            currency: ""
        },
        notification:{
            type: '',
            message: ''
        },
        countries: {} as ICountries
    }),
    actions: {
        setCurrentCountry(country: string) {
            this.currentCountry = country;
        },
        setSingleStock(status: string) {
            this.singleProduct.status = status;
        },
        setSingleVariation(id: number) {
            this.singleProduct.variationId = id;
        },
        setId(id: string) {
            this.wcId = id;
        },

        setCart(carts: any) {
            this.carts = carts;
        },

        setCartTotal(total: number) {
            this.totalItemCart = total;
        },
        setNotification (type: string, message: string) {
            this.notification.type = type;
            this.notification.message = message
        },
        setNewsletterShowed(value: boolean) {
            this.newsletterShowed = value;
        },

        removeNotification() {
            this.notification.type = '';
            this.notification.message = '';
        },

        setCurrency(currency: ICurrencyItem) {
            this.currency = currency;

            useCookie('altcs_currency', cookieOptions).value = currency.currency
        },

        setCountry(country: ICurrencyCountry) {
            this.country = country;

            useCookie('altcs_detect_country', cookieOptions).value = country.country_short
            useCookie('altcs_detect_country_flag', cookieOptions).value = country.flag
            useCookie('altcs_popup_display', cookieOptions).value = country.label
        },

        setCurrencyList(currencies: ICurrencyList) {
            this.currencyList = currencies;
        },

        setCountries(countries: ICountries) {
            this.countries = countries;
        },
        triggerNewsletter() {
            this.newsletterTriggerCount += 1;
        },
    },
});